import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-slate-950 border-t border-slate-900 py-8 mt-auto">
      <div className="max-w-6xl mx-auto px-4 text-center md:text-left">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="bg-blue-600/10 p-1.5 rounded-md border border-blue-500/20">
              <SafeIcon icon={FiIcons.FiShield} className="text-blue-500 text-sm" />
            </div>
            <span className="text-sm font-black text-white">
              AI<span className="text-blue-500">Investigator</span>
            </span>
          </div>
          
          <div className="text-xs text-slate-500 flex flex-col items-center md:items-end">
            <p>© {currentYear} Neural Forensic Suite</p>
            <p className="font-bold mt-1">
              Powered by <a href="https://takedowntaskforce.com" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-400">TakedownTaskforce.com</a>
            </p>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-slate-900/50 text-center">
          <p className="text-[9px] text-slate-600 uppercase tracking-[0.3em] font-black">
            Advanced Neural Image Analysis • Private Local Runtime • Trusted Forensic Engine
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;